module.exports = __webpack_public_path__ + "img/rr4.5f127aa9.png";